import { render, staticRenderFns } from "./500.vue?vue&type=template&id=58afb636&scoped=true&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=58afb636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58afb636",
  null
  
)

export default component.exports